export const SeverityFieldNames = {
  component: "component",
  material: "material",
  defect: "defect",
  severity: "severity",
  probability: "probability",
  consequence: "consequence",
  risk: "risk",
} as const;

export const COMPONENT_FIELD_DEPENDENCIES = Object.freeze(
  Object.keys(SeverityFieldNames).filter(
    (key) => key !== SeverityFieldNames.component
  )
);

export const MATERIAL_FIELD_DEPENDENCIES = Object.freeze(
  COMPONENT_FIELD_DEPENDENCIES.filter(
    (key) => key !== SeverityFieldNames.material
  )
);

export const DEFECT_FIELD_DEPENDENCIES = Object.freeze(
  MATERIAL_FIELD_DEPENDENCIES.filter((key) => key !== SeverityFieldNames.defect)
);

export const DEFAULT_NUMBER_OF_LEVELS = 5;
export const CRITERIA_I18N_KEY_PREFIX = "form:staticField.severity.levels";
